export default "__VITE_ASSET__ByAjqpk3__"